/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  MeterUsageSeries,
  MeterUsageSeries$inboundSchema,
} from "./meterusageseries.js";

/**
 * Selected family-compatible breakdown dimension
 */
export const MeterUsageBreakdownDimension = {
  Total: "total",
  Project: "project",
  Model: "model",
  Provider: "provider",
  BillingMode: "billing_mode",
  Assistant: "assistant",
  BillingUser: "billing_user",
  Division: "division",
  Department: "department",
  JobTitle: "job_title",
  EmployeeType: "employee_type",
  CostCenter: "cost_center",
  DirectoryGroupSet: "directory_group_set",
  Direction: "direction",
  McpServer: "mcp_server",
  ServerType: "server_type",
  Scanner: "scanner",
  Policy: "policy",
  JudgeModel: "judge_model",
  JudgeProvider: "judge_provider",
  ToolName: "tool_name",
} as const;
/**
 * Selected family-compatible breakdown dimension
 */
export type MeterUsageBreakdownDimension = OpenEnum<
  typeof MeterUsageBreakdownDimension
>;

export type MeterUsageBreakdown = {
  /**
   * Selected family-compatible breakdown dimension
   */
  dimension: MeterUsageBreakdownDimension;
  /**
   * At most six selected facet series plus a remainder
   */
  series: Array<MeterUsageSeries>;
};

/** @internal */
export const MeterUsageBreakdownDimension$inboundSchema: z.ZodMiniType<
  MeterUsageBreakdownDimension,
  unknown
> = openEnums.inboundSchema(MeterUsageBreakdownDimension);

/** @internal */
export const MeterUsageBreakdown$inboundSchema: z.ZodMiniType<
  MeterUsageBreakdown,
  unknown
> = z.object({
  dimension: MeterUsageBreakdownDimension$inboundSchema,
  series: z.array(MeterUsageSeries$inboundSchema),
});

export function meterUsageBreakdownFromJSON(
  jsonString: string,
): SafeParseResult<MeterUsageBreakdown, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MeterUsageBreakdown$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MeterUsageBreakdown' from JSON`,
  );
}
